// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ErrorComponent$OrcaPaymentPage from "./ErrorComponent.bs.js";

function VGSInputComponent(props) {
  let __height = props.height;
  let __compact = props.compact;
  let __isFocused = props.isFocused;
  let __id = props.id;
  let __fieldName = props.fieldName;
  let __fieldName_value = __fieldName !== undefined ? __fieldName : "";
  let __id_value = __id !== undefined ? __id : "";
  let __isFocused_value = __isFocused !== undefined ? __isFocused : false;
  let __compact_value = __compact !== undefined ? __compact : false;
  let __height_value = __height !== undefined ? __height : "";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let config = match.config;
  let match$1 = config.appearance;
  let innerLayout = match$1.innerLayout;
  let match$2 = React.useState(() => "");
  let setFocusClass = match$2[1];
  React.useEffect(() => {
    setFocusClass(param => {
      if (__isFocused_value) {
        return "VGSField--focused";
      } else {
        return "";
      }
    });
  }, [__isFocused_value]);
  let inputClassStyles = innerLayout === "Spaced" ? "Input" : "Input-Compressed";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
        condition: __fieldName_value.length > 0 && config.appearance.labels === "Above" && innerLayout === "Spaced",
        children: JsxRuntime.jsx("div", {
          children: __fieldName_value,
          "aria-hidden": true,
          className: "Label Label--empty",
          style: {
            fontSize: themeObj.fontSizeLg,
            fontWeight: themeObj.fontWeightNormal,
            marginBottom: "5px",
            opacity: "0.6"
          }
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                  className: inputClassStyles + ` Input--empty focus:outline-none transition-shadow ease-out duration-200 ` + match$2[0],
                  id: __id_value,
                  style: {
                    background: themeObj.colorBackground,
                    boxSizing: "border-box",
                    height: __height_value,
                    padding: __compact_value ? `0px ` + themeObj.spacingUnit : themeObj.spacingUnit,
                    width: "100%"
                  }
                }),
                className: "flex flex-row"
              }),
              JsxRuntime.jsx(ErrorComponent$OrcaPaymentPage.make, {
                errorStr: Primitive_option.some(props.errorStr)
              })
            ],
            className: "flex flex-col w-full",
            style: {
              color: themeObj.colorText
            }
          }),
          className: "relative w-full"
        }),
        className: "flex flex-row",
        style: {
          direction: "ltr"
        }
      })
    ],
    className: "flex flex-col w-full",
    style: {
      color: themeObj.colorText
    }
  });
}

let make = VGSInputComponent;

export {
  make,
}
/* jotai Not a pure module */
